import '~/style.css'

import { Fragment, h } from 'preact'
import { Router } from 'preact-router'

import { AppBar } from '~/components/app-bar'
import { AppContainer } from '~/components/app-container'
import { About } from '~/pages/about'
import { Contact } from '~/pages/contact'
import { Home } from '~/pages/home'
import { Member } from '~/pages/member'
import { Rule } from '~/pages/rule'

const Index = () => {
  return (
    <Fragment>
      <AppBar />
      <AppContainer>
        <Router>
          <Home path="/" />
          <About path="/about" />
          <Member path="/member" />
          <Contact path="/contact" />
          <Rule path="/rule" />
        </Router>
      </AppContainer>
    </Fragment>
  )
}

export default Index
